var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer",class:{ active: _vm.isActive }},[_c('div',{staticClass:"copyright"},[_vm._v("Copyright© 2022")])])
}
var staticRenderFns = []

export { render, staticRenderFns }